<template>
  <el-dialog :title="title" :visible.sync="vDialog" :close-on-click-modal="false" append-to-body>
    <div class="search">
      <div class="search-title">请输入关键词</div>
      <el-input v-model="searchVal" placeholder="请输入关键词" class="search-input" @change="queryData"></el-input>
      <el-button type="primary" @click="queryData">搜索</el-button>
    </div>
    <el-table height="500" :data="tableData" :highlight-current-row="!isMultiple" @selection-change="selsChange"
      @current-change="changeCurrentData" @row-dblclick="rowDbClick" class="table-content" :border="true">
      <el-table-column v-if="tableData.length > 0 && isMultiple" type="selection" width="50"></el-table-column>
      <el-table-column v-for="(item, index) in Object.keys(columns)" :key="index" :prop="item"
        :label="columns[item].label" :width="columns[item].width ? columns[item].width : ''"
        :formatter="columns[item].filter ? columns[item].filter : null"></el-table-column>
      <el-table-column prop="Status" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="tableData.length > 0" background layout="prev, pager, next,sizes" :total="total"
      @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :current-page="pageIndex"
      :page-size="pageSize" @size-change="handleSizeChange" class="pager"></el-pagination>
    <div slot="footer" class="dialog-footer">
      <el-button @click="vDialog = false">取消</el-button>
      <el-button type="primary" @click="callback">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "TableDataDialog",
  data() {
    return {
      tableData: [],
      searchVal: "",
      selData: [],
      total: 0,
      pageSize: 20,
      pageIndex: 1,
      vDialog: this.visibleDialog,
      currentData: null,
      selectOpType: 1,
    };
  },
  props: {
    //弹出框显示的标题
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
    //带入弹出框的查询条件
    visibleDiaInitQuery: {
      type: String,
      default: () => {
        return "";
      },
    },
    //弹出框的显示状态
    visibleDialog: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    /**
     * 表格的列,传输一个对象
     * {
     *  Name:{  //数据的属性名
     *    label:'名称',  //列头显示的字符串
     *    width:300,  //列宽
     *    filter:(arg)=>{ //处理单列数据的方法
     *      //DO SOMETHING
     *    }
     *  },
     *  {
     *    Age:{  //数据的属性名
     *    label:'年龄',  //列头显示的字符串
     *    filter:(arg)=>{ //处理单列数据的方法
     *      //DO SOMETHING
     *    }
     *  },
     *  //...More
     * }
     */
    columns: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //查询数据的方法,需要与标准的分页接口一致
    queryMethod: {
      type: Function,
      default: null,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  }, //接受父组件传值
  methods: {
    callback() {
      // if (this.isMultiple) {
      //   this.$emit("callback", this.selData);
      // } else {
      //   this.$emit("callback", this.currentData);
      // }
      this.$emit("callback", [this.currentData]);
    },
    queryData() {
      if (this.selectOpType == 1) {
        this.pageIndex = 1;
      }
      this.selectOpType = 1;
      if (this.queryMethod) {
        let para = {
          page: this.pageIndex,
          key: this.searchVal,
          intPageSize: this.pageSize,
        };
        this.queryMethod(para)
          .then((res) => {
            this.total = res.data.response.dataCount;
            this.tableData = res.data.response.data;
          })
          .catch(() => {
            this.reset();
          });
      }
    },
    reset() {
      this.total = 0;
      this.pageSize = 10;
      this.pageIndex = 1;
      this.searchVal = "";
      this.tableData = [];
    },
    selsChange(sels) {
      this.selData = sels;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.selectOpType = 0;
      this.queryData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.queryData();
    },
    changeCurrentData(item) {
      this.currentData = item;
    },
    rowDbClick(item) {
      this.currentData = item;
      this.selData = [];
      this.selData.push(item);
      this.callback();
    },
  },
  mounted() { },
  watch: {
    visibleDialog(val) {
      if (val) {
        if (this.visibleDiaInitQuery) {
          this.searchVal = this.visibleDiaInitQuery;
        } else {
          this.searchVal = null;
        }
        this.queryData();
      } else {
        this.pageIndex = 1;
      }
      this.vDialog = val;
    },
    /*visibleDiaInitQuery(val) {
      if (val) {
        this.searchVal = val;
        this.queryData();
      }
    },*/
    vDialog(val) {
      this.$emit("getDialogVisible", val);
    },
  },
};
</script>
<style lang="less" scoped>
.table-content {
  width: 100%;
}

.pager {
  text-align: center;
  margin-top: 20px;
}

.search {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &-input {
    width: 200px;
    margin: 0 20px;
  }
}
</style>
